import React, { ReactNode } from 'react';

/** 12-column grid on large screens, a single column below. Children are SectionCards. */
export function SectionGrid({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">{children}</div>;
}

export default SectionGrid;
